export const PortfolioPayload = {
  isDefault: false,
  emails: [
    {
      firstName: 'Test',
      lastName: 'User',
      emailAddress: 'test@connectportal.com',
    },
  ],
  emailSubject: 'Notifications',
  emailLanguage: 'gb',
  frequency: 'DailyDigest',
}

export const CompanyPayload = {
  personalReference: 'Test Company',
  includeBranches: true,
  freeText: 'Test text',
  personalLimit: '100',
}

export const EncodeURLComponent = (data) => {
  let params = ''
  for (let key in data) {
    if (data[key]) {
      if (data[key].includes('&')) {
        let encodedParams = encodeURIComponent(data[key])
        params += `${params === '' ? '' : '&'}${key}=${encodedParams}`
      } else {
        params += `${params === '' ? '' : '&'}${key}=${data[key]}`
      }
    }
  }
  return params
}
export const encodeTranslationText = (text) => {
  const encodedText = text.replace(/^\s+|\s+$/gm, '')
  return encodeURIComponent(encodedText)
}



// WEBPACK FOOTER //
// ./src/store/util.js